import { combineReducers } from '@reduxjs/toolkit';

import { endorsementReducer } from './endorsementData/reducer';
import { endorsementModalSettingsReducer } from './settings/reducer';

export const endorsementRootReducer = combineReducers({
  endorsementsData: endorsementReducer,
  settings: endorsementModalSettingsReducer
});
